import { useToast } from '@chakra-ui/react';

import { FeatureFlag, getFlagValue } from '../../utils/common/feature-flag-helpers';

export function useDebugLogs() {
  const isEnabled = getFlagValue(FeatureFlag.EnableEVSELogs);
  const toast = useToast();

  const debugToast = (title: string, description: string, duration?: number) => {
    if (!isEnabled) return;

    toast({
      title: `DBG: ${title}`,
      description,
      status: 'info',
      duration: duration || 5000,
      isClosable: true,
    });
  };

  const debugLog = (message: string) => {
    console.log(message);
  };

  return { debugToast, debugLog };
}
